import axios from "axios";
import {Link} from 'react-router-dom';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function IpLabPayment(){
    const [labData,setlabData] = useState([]);
    const [amount, setAmount] = useState(0);
    const [balance, setBalance] = useState(0);
    const [iptotData,setIptotData] = useState([]);
    const {appt_id}=useParams();

    useEffect(() => {
        try{
            axios.get(baseUrl+'ip-lab-pay/'+appt_id)
            .then(function (response) {
                setlabData(response.data);
                setAmount(response.data[0].lab_tot);
                setBalance(0);
            });
        }catch(error){
            console.log(error);
        }
    },[]);

    const handleAmountChange = (event) => {
    let newAmount = parseInt(event.target.value, 10);
    const maxAmount = labData[0].lab_tot;
     if (newAmount > maxAmount) {
        newAmount = maxAmount;
    }
     setAmount(newAmount);
    setBalance(maxAmount - newAmount);
};

    const handlePaymentTypeChange = (event) => {
      const value = event.target.value;
      if (value === 'creditpay') {
        setAmount(0);
        setBalance(labData[0].lab_tot);
      } else {
        setAmount(labData[0].lab_tot);
        setBalance(0);
      }
    }
  useEffect(() => {
     if (labData.length > 0) {
      fetchIptotData();
    }
  }, [labData]);

   const fetchIptotData = async () => {
    const ip_id = labData[0].ip.id;
    try {
      const response = await axios.get(baseUrl + "view-ip-tot/" + ip_id);
      setIptotData([response.data]);
    } catch (error) {
      console.log(error);
    }
  };

   const handleFormSubmit = (e) => {
      e.preventDefault();
        const dbType = document.getElementById('dbType').value;
          axios.post(`${baseUrl}get_sale_lab/`)
          .then(response => {
          const sale_lab = response.data.value;
          const _formData = new FormData();
          _formData.append('lab_paid',amount);
          _formData.append('lab_balance',balance);
          _formData.append('lab_invoice',sale_lab);
          _formData.append('lab_pmode',dbType);
          _formData.append('cashier',userName);
          _formData.append('lab_status','2');
            axios.post(baseUrl+'ip-lab-payment/'+appt_id+'/', _formData, {
                  headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(response => {
              if(response.status==200 || response.status==201){
                if(dbType=='advance'){
                const tot_invoiced = parseFloat(iptotData[0][0].tot_invoiced) + parseFloat(amount);
                const tot_paid = parseFloat(iptotData[0][0].tot_paid) + parseFloat(amount);
                const tot_balance = parseFloat(iptotData[0][0].tot_balance) + parseFloat(balance);
                const remain_balance = parseFloat(iptotData[0][0].remain_balance) - parseFloat(amount);
                const tot_used = parseFloat(iptotData[0][0].tot_used) + parseFloat(amount);
                const IpId = iptotData[0][0].id;
                _formData.append('tot_invoiced',tot_invoiced.toFixed(2));
                _formData.append('tot_paid',tot_paid.toFixed(2));
                _formData.append('tot_balance',tot_balance.toFixed(2));
                _formData.append('remain_balance',remain_balance.toFixed(2));
                _formData.append('tot_used',tot_used.toFixed(2));
                _formData.append('addedby',userName);
                _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
                axios.put(`${baseUrl}update-ip-tot/${IpId}/`, _formData)
                .then(response => {
                    console.log(response.data);
                });
                }
                Swal.fire({
                  title: 'Payment Success and Invoice is Generated',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                })
                setTimeout(() => {
                  window.location.href = ('/lab-invoice-ip/'+sale_lab+'/');
                }, 3000);
              }
              })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add lab entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };


    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className="row">
                    <h3 className="text-center"> IP Lab Payment</h3>
                    <div className="table-responsive">
                      <table className="erp-table-modern">
                        <thead>
                              <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                <th>Appointment Id</th>
                                <th>Patient Id</th>
                                <th>Patient Name</th>
                                <th>Addedby</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {labData.map((row,index) =>
                                  <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                    <td>{appt_id}</td>
                                    <td>{row.pat.pat_id}</td>
                                    <td>{row.pat.patient}</td>
                                    <td>{row.addedby}</td>
                                    <td>{row.lab_tot}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <form>
                        <label>Choose Payment Type</label>
                        <select name="dbType" id="dbType" onChange={handlePaymentTypeChange}>
                           <option value="advance">From Advance</option>
                           <option value="cash">Cash</option>
                           <option value="card">Card</option>
                           <option value="creditpay">Credit Payment</option>
                           <option value="UPI">UPI</option>
                        </select>
                        <div className="form-group mt-3" >
                            <label style={{ fontWeight: 'bold' }}>Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" name="amount" id="amount" value={amount} onChange={handleAmountChange} max={amount}/>
                            </div>
                        </div>
                        <div className="form-group mt-3" >
                            <label style={{ fontWeight: 'bold' }}>Balance Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" name="balance" id="balance" value={balance}
                                    onChange={handleAmountChange} readOnly />
                            </div>
                        </div>
                         <button type="button" onClick={handleFormSubmit} className="btn btn-primary mt-4">
                         Submit</button>
                   </form>
              </div>
            </div>
            </div>
            </div>
        </section>

)
}

export default IpLabPayment;